import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";
import { CommissionCategoriesRefData } from "../domain/CommissionCategoriesRefData";

export const RefDataSort = (data: CommissionCategoriesRefData[]) => {
  const compare = (a: number, b: number) => (a > b ? 1 : 0) - (a < b ? 1 : 0);
  return data.sort((a, b) => 
    compare(a.sortOrder, b.sortOrder) || a.lookupValue.localeCompare(b.lookupValue)
  );
}

export const RefDataMap = (data: CommissionCategoriesRefData[]) => {
  return data.map(x => ({ id: x.id, label: x.lookupValue, active: x.active }));
}

export class CommissioningCategoriesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/commissioningcategories`;
    const data = await super.getRequest<CommissionCategoriesRefData[]>(url, opts);
    return RefDataMap(RefDataSort(data));
  }
}
